module.exports = __webpack_public_path__ + "img/scale_white.8b8c442f.svg";